import { gql } from "@apollo/client"

export type EledoStructure = {
  key: string
  value: string
}

export type EledoStructures = {
  total: number
  items: [EledoStructure]
}

export type EledoStructuresData = {
  structures: EledoStructures
}

export type EledoStructuresVars = {
  connectionId: string
  limit?: number
  page?: number
}

export const GET_STRUCTURES = gql`
  query getStructures($connectionId: ObjectId!, $limit: Int, $page: Int) {
    structures(connectionId: $connectionId, limit: $limit, page: $page) { items { key value } total }
  }
`;